import type { MarqueeRect } from '@/components/canvas/workspace/controllers/marqueeSelectUtils';
import { SelectionChromeFrame } from '@/components/canvas/selection/SelectionChromeFrame';

export interface WorldMarqueeLayerProps {
  marquee: MarqueeRect | null;
  zoom: number;
}

/** 世界坐标圈选框，挂在 workspace-stage 下 */
export function WorldMarqueeLayer({ marquee, zoom }: WorldMarqueeLayerProps) {
  if (!marquee) return null;
  return (
    <div
      className="pointer-events-none absolute z-[200] bg-accent/20"
      style={{
        left: marquee.x,
        top: marquee.y,
        width: marquee.width,
        height: marquee.height,
      }}
    >
      <SelectionChromeFrame
        left={0}
        top={0}
        width={marquee.width}
        height={marquee.height}
        zoom={zoom}
      />
    </div>
  );
}
